import { PlaceholderApi } from 'api/PlaceholderApi';
import { backendApiClient } from 'container/backendApiClient';

export const placeholderApi = new PlaceholderApi(backendApiClient);
